module.exports = __webpack_public_path__ + "static/booking-done-d4bca79aba69217040706e38c085813b.svg";